import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Label } from 'core/components/label';
import { useObserver } from 'mobx-react';
import { useStore } from 'core/store/store.mobx';
import { useFormikContext } from 'formik';
import DialogError from '../dialog-error';

const AutoOnly = ({ errors = [], rejections = [], classes }) => {
  const { values, resetForm } = useFormikContext();
  const { offer: store } = useStore();

  useEffect(() => {
    resetForm(values);
  }, []);

  return useObserver(() => (
    <>
      <Label type="titleSecondary" className={classes.title}>
        We can only offer Auto&Renters policy
      </Label>
      <Label type="infoInnerTitle" className={classes.content}>
        There’s been a Home policy rejection:
      </Label>
      {[...errors, ...rejections].map((error, index) => (
        <DialogError key={`${error.code}-${index}`} error={error} />
      ))}
      <Grid container alignItems="center" justifyContent="flex-end" className={classes.bottom}>
        <Button className={classes.link} variant="text" color="secondary" component={Link} to="/quote">
          Create new offer
        </Button>
        <Button
          className={classes.btn}
          onClick={() => store.triggerOfferDialog(false)}
          variant="contained"
          color="primary"
        >
          <Label className={classes.btnLabel}>Continue to current offer</Label>
        </Button>
      </Grid>
    </>
  ));
};

AutoOnly.propTypes = {
  errors: PropTypes.array.isRequired,
  rejections: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired
};

export default AutoOnly;
